var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.23,
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#D0D8DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0702 30.9417C31.9406 31.1577 31.7438 31.3305 31.523 31.4505C24.7646 33.5241 18.4046 33.5673 12.4767 31.4505C12.2559 31.3305 12.0591 31.1577 11.9295 30.9417C9.12625 26.1945 11.2479 15.7209 11.2479 15.7209C11.5647 14.2425 15.8942 13.5081 17.3006 13.3065C18.3326 11.8953 19.9934 10.9785 21.8702 10.9785C23.1758 10.9785 24.3806 11.425 25.3358 12.1689C25.4174 12.2313 25.4942 12.2937 25.5662 12.3609C25.8494 12.6153 26.0894 12.9129 26.2622 13.2489C26.2622 13.2489 26.315 13.2537 26.4062 13.2681C27.3326 13.3881 32.411 14.1177 32.7518 15.7209C32.7518 15.7209 34.8734 26.1945 32.0702 30.9417Z",
    fill: "#CDCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7712 15.8467C31.7712 15.8467 33.1949 23.4979 31.4465 29.4209C31.2618 30.0465 30.7958 30.5506 30.1807 30.7678C29.3297 31.0683 27.8417 31.4471 25.43 31.6476C24.1345 31.7552 22.9503 30.9019 23.1003 29.2634C23.3022 27.0577 23.6595 23.5471 26.0361 21.7453C27.5916 20.5659 28.3241 18.4325 27.5431 16.1136C27.2872 15.3538 27.0724 14.3173 27.8882 14.4972C29.1542 14.7762 31.6363 14.9978 31.7712 15.8467Z",
    fill: "#535352"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8171 29.3291C24.0009 27.3205 24.3086 23.9586 26.4709 22.3191C28.4358 20.8295 29.0349 18.2883 28.2252 15.8839C28.1336 15.6113 28.0846 15.4105 28.0588 15.2666C28.2531 15.3041 28.4594 15.3404 28.6738 15.3782C29.3596 15.4991 30.7656 15.7466 31.0722 16.0286C31.2053 16.7985 32.3493 23.8185 30.7558 29.2171C30.6353 29.6254 30.3307 29.9514 29.9409 30.089C29.1613 30.3641 27.7356 30.7335 25.3701 30.9303C24.4207 31.0083 23.7169 30.4224 23.8171 29.3291Z",
    fill: "#676767"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2294 15.8467C12.2294 15.8467 10.8057 23.4979 12.554 29.4209C12.7387 30.0465 13.2048 30.5506 13.8198 30.7678C14.6709 31.0683 16.1588 31.4471 18.5705 31.6476C19.8661 31.7552 21.0503 30.9019 20.9003 29.2634C20.6983 27.0577 20.3411 23.5471 17.9644 21.7453C16.409 20.5659 15.6764 18.4325 16.4574 16.1136C16.7133 15.3538 16.9282 14.3173 16.1123 14.4972C14.8464 14.7762 12.3642 14.9978 12.2294 15.8467Z",
    fill: "#535352"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6301 30.9301C16.2648 30.7332 14.8391 30.3639 14.0596 30.0887C13.6698 29.9512 13.3653 29.6251 13.2446 29.2169C11.6368 23.7702 12.8122 16.6921 12.9284 16.0283C13.235 15.7464 14.6408 15.4989 15.3263 15.3779C15.5424 15.3399 15.7501 15.3034 15.9415 15.2666C15.9158 15.4105 15.8668 15.6111 15.7751 15.8835C14.9643 18.2917 15.5709 20.8341 17.5294 22.319C19.6918 23.9584 19.9995 27.3203 20.1833 29.3289C20.2835 30.4224 19.5798 31.0078 18.6301 30.9301Z",
    fill: "#676767"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9435 16.6356C26.9435 19.4362 24.6657 21.7036 21.8704 21.7036C19.0698 21.7036 16.7972 19.4362 16.7972 16.6356C16.7972 13.835 19.0698 11.5625 21.8704 11.5625C24.6657 11.5625 26.9435 13.835 26.9435 16.6356Z",
    fill: "#D25C59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3213 16.6355C26.3213 19.0926 24.3229 21.0818 21.8703 21.0818C19.4133 21.0818 17.4194 19.0926 17.4194 16.6355C17.4194 14.1784 19.4133 12.1846 21.8703 12.1846C24.3229 12.1846 26.3213 14.1784 26.3213 16.6355Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2921 13.3262L19.8105 13.9358L19.5753 14.1326L19.0569 13.523L19.2921 13.3262Z",
    fill: "#676767"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5787 12.6445L20.8523 13.3933L20.5691 13.4989L20.2954 12.7453L20.5787 12.6445Z",
    fill: "#676767"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7162 12.4424H22.0234V13.244H21.7162V12.4424Z",
    fill: "#676767"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8601 18.1982L19.0089 18.4622L18.3177 18.8606L18.1641 18.5966L18.8601 18.1982Z",
    fill: "#676767"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7737 15.7559L18.5612 15.895L18.5077 16.1975L17.7202 16.0584L17.7737 15.7559Z",
    fill: "#676767"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3177 14.4062L19.0089 14.8047L18.8601 15.0687L18.1641 14.6703L18.3177 14.4062Z",
    fill: "#676767"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7185 17.2119L18.506 17.0728L18.5594 17.3753L17.7719 17.5144L17.7185 17.2119Z",
    fill: "#676767"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5754 19.1338L19.8106 19.3306L19.2923 19.9402L19.057 19.7434L19.5754 19.1338Z",
    fill: "#676767"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5691 19.7676L20.8523 19.8732L20.5787 20.622L20.2954 20.5212L20.5691 19.7676Z",
    fill: "#676767"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1704 14.1289L23.9352 13.932L24.4469 13.3207L24.6822 13.5175L24.1704 14.1289Z",
    fill: "#676767"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7163 20.0215H22.0235V20.8231H21.7163V20.0215Z",
    fill: "#676767"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4541 19.9395L23.9407 19.3295L24.1753 19.132L24.6887 19.7419L24.4541 19.9395Z",
    fill: "#676767"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.161 12.6445L23.449 12.7453L23.1754 13.4989L22.8875 13.3933L23.161 12.6445Z",
    fill: "#676767"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4246 18.8701L24.7333 18.4718L24.8857 18.2073L25.577 18.6056L25.4246 18.8701Z",
    fill: "#676767"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4238 14.3994L25.5774 14.6632L24.888 15.0646L24.7344 14.8008L25.4238 14.3994Z",
    fill: "#676767"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1754 19.7676L23.449 20.5212L23.161 20.622L22.8875 19.8732L23.1754 19.7676Z",
    fill: "#676767"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2345 17.0693L26.0264 17.2085L25.9689 17.5109L25.1816 17.3717L25.2345 17.0693Z",
    fill: "#676767"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0259 16.0547L25.2339 16.1938L25.1808 15.8912L25.9727 15.7521L26.0259 16.0547Z",
    fill: "#676767"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.439 15.3916L23.1262 15.1963L22.2761 16.5583L21.8174 16.272L22.6674 14.91L22.3477 14.7104L23.3317 14.3564L23.439 15.3916Z",
    fill: "#B5B5B6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8702 17.3909C22.2888 17.3909 22.6281 17.0515 22.6281 16.6329C22.6281 16.2143 22.2888 15.875 21.8702 15.875C21.4516 15.875 21.1123 16.2143 21.1123 16.6329C21.1123 17.0515 21.4516 17.3909 21.8702 17.3909Z",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyWeight);
export default __webpack_public_path__ + "static/media/bodyWeight.17e99e4b50cb80ce0e7fb2f1ea21ad3e.svg";
export { ForwardRef as ReactComponent };